import React from 'react';
import SellYourBoatFormProps from "./props";
import DynamicContactForm from '../../private/DynamicContactForm';
import Title from '../../private/Title';
import TitleProps from '../../private/Title/props';

import './sell-your-boat.scss';

function SellYourBoatForm(props: SellYourBoatFormProps) {
  return (
    <div className="sell-your-boat">
      <Title {...useTitleProps(props.title)} />
      { props?.note && <i>{ props.note }</i> }
      <DynamicContactForm {...props} cssPrefix="sell-boat-form" />
      { props.children }
    </div>
  );
}

const useTitleProps = (title: string): TitleProps => ({
  classNames: { 'title-12': true },
  text: title
})

export default React.memo(SellYourBoatForm);